import React from "react";
import { useNavigate } from "react-router-dom";
import { workshopsReach as workshops } from "../constants/workshops";
import Session from "../components/Session";
import { LoaderData } from "../context/loaderContext";
import Loader from "../components/Loader/Loader";
const Workshops = () => {
  const navigate = useNavigate();
  const white = "#fff";


  const { isLoading } = LoaderData();

  if (isLoading) {
    return <Loader />;
  }
  return (
    <div className="bg-black min-h-screen flex justify-center items-center pt-8 ">
      <div className="w-full max-w-7xl px-4 ">
        <h2
          style={{ color: white }}
          className="my-5 mt-20 text-5xl font-bold text-[#fcfcfc] text-center mb-8 overflow-hidden [text-shadow:6px_2px_4px_#ab8e5c]"
        >
          Workshops
        </h2>

        <div className="grid sm:grid-cols-1 lg:grid-cols-2 gap-8 ">
          {workshops.map((workshop) => (
            <div
              key={workshop.id}
              className="border-[2px] border-[#ab8e5c] bg-[#1d1d1d] text-white p-6 rounded-lg shadow-lg hover:shadow-2xl transition-shadow lg:col-span-2 mx-auto w-full max-w-xl"
            >
              <h3
                className="text-xl font-semibold mb-4 border-b-2 pb-4"
                // style={{ borderBottomColor: burgundy }}
              >
                # {workshop.title}
              </h3>
              <div className="">
                <img
                  src={workshop.image}
                  alt={`Workshop ${workshop.id}`}
                  className="w-full h-48 object-contain rounded-md hover:bg-[#303030]"
                  onClick={() => {
                    navigate(`${workshop.to}`);
                  }}
                />
              </div>
              <p className="text-lg font-medium pt-4">{workshop.description}</p>
              <button
                  className="my-3 px-4 py-2 bg-[linear-gradient(135deg,rgb(184,149,106)_0%,rgb(139,110,61)_25%,rgb(192,160,104)_50%,rgb(184,149,106)_75%,rgb(157,127,82)_100%)] text-white font-bold rounded-full shadow-lg hover:shadow-[0_0_10px_rgba(255,255,255,0.8)] transition-shadow focus:outline-none focus:shadow-[0_0_15px_rgba(255,223,47,0.8)]"
                  onClick={() => {
                    navigate(`${workshop.to}`);
                  }}
                >
                  Read More {`<~>`}
              </button>
            </div>
          ))}
        </div>
        <Session />
        
       
      </div>
    </div>
  );
};

export default Workshops;
